import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { HeaderLeftIcon } from './headerLeftIcon';
import productList from '../data/data.json';

export const Search = props => {
  const [ornament, setOrnament] = useState([]);
  const [search, setSearch] = useState('');

  const NewProductList = productList.products.filter(
    filterItem => filterItem.categ !== 'promo' && filterItem.categ !== 'cat'
  );
  const filtered = NewProductList.filter(product => {
    return product.alt
      .toString()
      .toLowerCase()
      .includes(search.toLowerCase());

    setOrnament(filtered);
  });

  const result = filtered.map(result => {
    return (
      <li key={result.id}>
        <Link
          to={{
            pathname: `product-page/${result.id}`,
            query: { id: result.id }
          }}
        >
          <img src={result.img} alt={result.alt} />
          <h4>{result.alt}</h4>
          <div>{result.price}</div>
        </Link>
      </li>
    );
  });
  if (search.length > 0) {
    return (
      <>
        <header className="search-page">
          <HeaderLeftIcon />
          <div className="search-bar" id="searchBox">
            <input
              onChange={e => setSearch(e.target.value)}
              type="text"
              value={search}
              placeholder="Search Product"
              ref={input => input && input.focus()}
            />
          </div>
          <div className="right-icon">
            <button>
              <span />
              <span />
            </button>
          </div>
        </header>
        <div className="main custom-scroll">
          <ul className="search-results">{result}</ul>
        </div>
      </>
    );
  } else {
    return (
      <>
        <header className="search-page">
          <HeaderLeftIcon />
          <div className="search-bar">
            <input
              onChange={e => setSearch(e.target.value)}
              type="text"
              value={search}
              placeholder="Search Product"
              ref={input => input && input.focus()}
            />
          </div>
          <div className="right-icon">
            <i className="fa fa-search" aria-hidden="true"></i>
          </div>
        </header>
        <div className="main custom-scroll">
          <div className="">
            <h1
              style={{
                marginTop: 15,
                textAlign: 'left',
                fontSize: 14,
                fontWeight: 'normal',
                color: 'black',
                textTransform: 'uppercase'
              }}
            >
              Suggestions
            </h1>
            <div className="tags" style={{ paddingLeft: 15, marginBottom: 30 }}>
              <Link to="/search">Diamond</Link>
              <Link to="/search">Gold</Link>
              <Link to="/search">New Arrival</Link>
            </div>

            <h1
              style={{
                textAlign: 'left',
                fontSize: 14,
                fontWeight: 'normal',
                color: 'black',
                textTransform: 'uppercase'
              }}
            >
              Popular Search
            </h1>
            <div className="tags" style={{ paddingLeft: 15 }}>
              <Link to="/search">Diamond</Link>
              <Link to="/search">Anniversary Gift</Link>
              <Link to="/search">Gold</Link>
              <Link to="/search">Silver Ornaments</Link>
              <Link to="/search">For Him</Link>
              <Link to="/search">Necklace Design</Link>
            </div>
          </div>
        </div>
      </>
    );
  }
};
